// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"09b3d371","330":"f914a841","520":"f13228c6","803":"93ac98e7","844":"3b7c1b50","891":"7d0faad6"}[chunkId] + ".chunk.css";
};